const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.userInfo.type,
  permissions: state => state.user.permissions,
  permission_routes: state => state.permission.routes,
  userInfo: state => state.user.userInfo,
  annualInfo: state => state.permission.annualInfo,
  auditManager: state => state.user.auditManager,
  mssageUnreadCount: state => state.user.mssageUnreadCount,
  metaMaskObj: state => state.app.MetaMaskObj,
  contractMap:state => state.app.contractMap,
  gas:state => state.app.gas,
  accountTypes:state => state.app.accountTypes,
  producerAuthSatatus:state => state.app.producerAuthSatatus
}
export default getters
